import { call, put, takeEvery } from "redux-saga/effects";
import { doiTuongDaoTaoApi } from "../../../api/category/doiTuongDaoTaoApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eDoiTuongDaoTaoActionIds } from "../../action-types/category/IStuDoiTuongDaoTaoActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.doiTuongDaoTao;

export function* doiTuongDaoTaoSaga(): any {
  yield takeEvery(eDoiTuongDaoTaoActionIds.LOAD_START, loadWorker);
}
function* loadWorker(): any {
  const res: IBaseRespone = yield call(doiTuongDaoTaoApi.SelectAll);
  if (res.is_success) yield put(mainAction.LOAD_SUCCESS(res.data));
  else yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
}
